@if ((isAuthenticated$ | async) !== true) {
  <app-auth>
    <ng-template appAuthContent>
      <router-outlet />
    </ng-template>
  </app-auth>
} @else {
  <app-sidebar-layout />
}
